.tableWrapper {
	width: 100%;
	margin-bottom: 20px;

	.tableContainer {
		width: 100%;
		background-color: #ffffff;
		border: 1px solid #e0e0e0;
		border-radius: 10px 10px 0px 0px;
	}

	.table {
		min-width: 960px;
		overflow: scroll;
	}

	.tableHead {
		border: 1px solid #e0e0e0;

		height: 60px;
		min-height: 60px;
	}

	.tableHeadCell {
		padding: 16px 24px;

		font-weight: 400;
		font-size: 15px;
		line-height: 100%;
		letter-spacing: 0%;
		text-align: left;
		text-wrap: nowrap;

		position: sticky;
		top: -1px;
		z-index: 10;

		background-color: #f7f6fb;
	}

	.tableRow {
		background-color: #ffffff;

		height: 60px;
		min-height: 60px;

		border: 1px solid #efefef;

		font-weight: 400;
		line-height: 100%;
		font-size: 15px;
		letter-spacing: 3.5%;

		text-align: left;
		text-overflow: ellipsis;
		color: #575757;
	}

	.clickableRow {
		cursor: pointer;
	}

	.clickableRow:focus-visible {
		border: 2px solid var(--focus-outline-color-dark);
	}

	.tableRow:hover {
		background-color: #ececec;
	}

	.tableRow .tableCell {
		padding: 16px 24px;

		font-weight: 400;
		line-height: 100%;
		font-size: 15px;
		letter-spacing: 3.5%;

		text-align: left;
		text-wrap: nowrap;
		text-overflow: ellipsis;
		color: #575757;

		overflow: hidden;
		max-width: 0;
	}

	.tableRow .overflowCell {
		text-overflow: unset;
		overflow: unset;
		max-width: unset;
	}

	.toggleCell {
		padding: 20px;
		border: 0px;
	}

	.collapsibleCell {
		height: 0px;
		min-height: 0px;
		padding: 0px;
	}

	.collapsibleElement {
		height: auto;
		min-height: 0px;
		text-align: center;
		text-wrap: wrap;
		transition-duration: 240ms;
	}

	/* No results state */
	.noResultsContainer {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		overflow: hidden;

		min-height: 360px;
	}

	.noResultsImage {
		width: min(160px, 80%);
		height: auto;
		margin-bottom: 16px;
	}

	.noResultsText {
		text-align: center;
		font-size: 20px;
		font-weight: 600;
		margin: 1em 0;
		color: black;
	}

	.noResultsDescription {
		text-align: center;
		font-size: 16px;
		font-weight: 500;
		color: black;
	}
}

@keyframes pulse {
	0% {
		opacity: 0.6;
	}

	50% {
		opacity: 0.3;
	}

	100% {
		opacity: 0.6;
	}
}
